import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M1.90991 1.02002C1.90991 1.02002 2.40991 8.44994 3.55991 14.5599L4.87991 14.0599C4.87991 14.0599 6.69991 21.1599 12.3099 21.8199C16.6399 22.3299 26.1799 24.2999 26.1799 24.2999C26.1799 24.2999 36.5399 22.3299 40.8799 21.8199C46.4899 21.1599 48.3099 14.0599 48.3099 14.0599L49.6299 14.5599C50.7899 8.44994 51.2799 1.02002 51.2799 1.02002H1.90991Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
